import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { CustomerExportButton } from './CustomerExportButton'
import { PermissionNames } from '@getgreenline/homi-shared'
import { ImportDropzone } from './ImportDropzone'
import { CustomersApi } from '@getgreenline/customers'
import { Alert } from 'antd-v4'

interface Props {
  isModalOpen: boolean
  loadCustomers: () => Promise<void>
}

interface InjectedProps {
  currentUserStore?: CurrentUserStore
  currentCompanyStore?: CurrentCompanyStore
}

export const CreditBalanceTab: React.FC<Props & InjectedProps> = inject(
  'currentUserStore',
  'currentCompanyStore',
)(
  observer(({ isModalOpen, loadCustomers, currentUserStore, currentCompanyStore }) => {
    const canEditCreditBalances = currentUserStore!.hasPermissionAtEntity(
      PermissionNames.CAN_ADJUST_LOYALTY_BALANCE,
      currentCompanyStore!.company!.id,
    )

    return (
      <div>
        <p className='mb-4'>
          Export your customer list, set new <strong>Loyalty Balance</strong>, then import to bulk
          update.
        </p>

        <p className='mb-4'>
          <strong>Loyalty tiers </strong> can also be bulk updated from this tab. All other fields
          are uneditable.
        </p>

        <p className='mb-4'>Import limit of 30,000 customers</p>

        <CustomerExportButton />

        <Alert
          className='mt-3 mb-3'
          type='warning'
          showIcon
          message={<span>Point balances in the upload will replace any existing balances.</span>}
        />

        <ImportDropzone
          isModalOpen={isModalOpen}
          hasPermission={canEditCreditBalances}
          permissionErrorMessage={`You do not have "${PermissionNames.CAN_ADJUST_LOYALTY_BALANCE}" permission.`}
          onImport={CustomersApi.importCreditBalance}
          loadCustomers={loadCustomers}
        />
      </div>
    )
  }),
)
